import { FunctionComponent, useEffect } from "react";
import OnlineExam from "../../Components/OnlineExam/OnlineExam";
import "./Exam_participationPractice.scss";
import { useAppDispatch } from "../../Redux/Store/Hooks";
import { listExamID } from "../../Redux/Slices/Exam/ListExamIDSlice";
import OnlineExamPractice from "../../Components/OnlineExamPractice/OnlineExamPractice";
import AppBarnav from "../../Components/AppBar/AppBar";

interface ExamParticipationPracticeProps {}

const ExamParticipationPractice: FunctionComponent<
  ExamParticipationPracticeProps
> = () => {
  const dispatch = useAppDispatch();

  return (
    <>
      {" "}
      {/* <AppBarnav /> */}
      <OnlineExamPractice />
    </>
  );
};

export default ExamParticipationPractice;
